import { createSlice } from "@reduxjs/toolkit";

import { getUserThunk } from "../../services/user-thunk";

const userSlice = createSlice({
    name: 'user',
    initialState: {
        loading: false,
        user: null,
        currentUser: {},
        error: null
    },
    reducers: {
        updateUser(state, action) {
            return {
                ...state,
                ...action.payload
            }
        },
    },
    extraReducers : {
        [getUserThunk.pending]: (state, action) => {
            state.loading = true;
            state.currentUser = null;
        },
        [getUserThunk.fulfilled]: (state, action) => {
            state.currentUser = action.payload
            state.loading = false;
        },
        [getUserThunk.rejected]: (state, action) => {
            state.error = action.payload
            state.loading = false;
            state.currentUser = null
        },
    }
});

export const { updateUser } = userSlice.actions;
export default userSlice.reducer;